export default __webpack_public_path__ + "static/media/about-vision-1.98462ec7.png";